import { render, staticRenderFns } from "./VtexAccounts.vue?vue&type=template&id=6db64abf&scoped=true&"
import script from "./VtexAccounts.vue?vue&type=script&lang=js&"
export * from "./VtexAccounts.vue?vue&type=script&lang=js&"
import style0 from "./VtexAccounts.vue?vue&type=style&index=0&id=6db64abf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db64abf",
  null
  
)

export default component.exports